import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { Col } from 'react-bootstrap';
import { Courses } from '../../../types/schema';
import CourseCard from '../../ui/CourseCard';
import Pagination from '../Pagination';

export type CourseItemGridTemplateProps = {
  data: Courses[];
};

const CourseItemGridTemplate: React.FC<CourseItemGridTemplateProps> = ({ data }) => {
  const [coursesToShow, setCoursesToShow] = useState<Courses[]>(data.slice(9));
  const [page, setPage] = useState<number>(1);
  const totalPages = useMemo(() => {
    if (data.length % 9 !== 0) {
      return Math.trunc(data.length / 9) + 1;
    } else return data.length / 9;
  }, [data]);

  useEffect(() => {
    if (!totalPages) return;

    const start = 9 * page - 9;
    const end = page === totalPages ? data.length + 1 : 9 * page;

    setCoursesToShow(data.slice(start, end));
  }, [page, totalPages, data]);

  const handlePageChange = (num: number) => setPage(num);

  return (
    <Fragment>
      {coursesToShow.map((course, i) => (
        <CourseCard key={i} course={course} />
      ))}
      {totalPages > 1 ? (
        <Col md="12" className="text-center">
          <Pagination page={page} totalPages={totalPages} handlePageChange={handlePageChange} />
        </Col>
      ) : (
        ''
      )}
    </Fragment>
  );
};

export default CourseItemGridTemplate;
